// extracted by mini-css-extract-plugin
module.exports = {"box":"_457cb1f","boxIcon":"_bd64d56","boxText":"_93bbe3a"};